module.exports = __webpack_public_path__ + "img/SF6.2e2c4fb8.png";